import { BRAND } from '@crew/shared';

/*
 * רכיבי המיתוג. כל הופעה של הלוגו באפליקציה עוברת דרך כאן.
 * - BrandEmblem: הסמל (המשושה עם הסוס) בלבד — לפסים צרים, אייקונים ומסכי טעינה.
 * - BrandLockup: הסמל + שם החברה + הסלוגן כטקסט חי (חד בכל גודל, עובד גם על רקע כהה).
 * - BrandLogoFull: הלוגו המקורי המלא — רק על רקע בהיר (הכיתוב בו כהה).
 */

export function BrandEmblem({ size = 40, className = '' }: { size?: number; className?: string }) {
  return (
    <img
      src={BRAND.assets.emblem}
      alt={BRAND.name}
      width={Math.round(size * 0.85)}
      height={size}
      className={`shrink-0 select-none object-contain ${className}`}
      style={{ height: size, width: 'auto' }}
      draggable={false}
    />
  );
}

export function BrandLockup({
  size = 40,
  tone = 'dark',
  tagline = true,
}: {
  size?: number;
  tone?: 'dark' | 'light';
  tagline?: boolean;
}) {
  const light = tone === 'light';
  return (
    <div className="flex items-center gap-3">
      <BrandEmblem size={size} />
      <div className="leading-none">
        <div
          className={`font-extrabold tracking-tight ${light ? 'text-white' : 'text-ink'}`}
          style={{ fontSize: Math.max(15, size * 0.46) }}
        >
          {BRAND.name}
        </div>
        {tagline && (
          <div className={`mt-1 ${light ? 'text-steel' : 'text-ink-3'}`} style={{ fontSize: Math.max(11, size * 0.28) }}>
            {BRAND.tagline}
          </div>
        )}
      </div>
    </div>
  );
}

export function BrandLogoFull({ height = 140, className = '' }: { height?: number; className?: string }) {
  return (
    <img
      src={BRAND.assets.logoFull}
      alt={`${BRAND.name} — ${BRAND.tagline}`}
      className={`select-none object-contain ${className}`}
      style={{ height, width: 'auto' }}
      draggable={false}
    />
  );
}
